/* A parent/child relation is not a reference in Ardoq, so it has no reference type to take a
   name from — every view that draws one supplies the words itself. */

import { t, type I18nLocale } from '@ardoq/i18n';
import { IS_CHILD_OF, IS_PARENT_OF } from '@ardoq/global-consts';

export const isParentOfLabel = (i18nLocale: I18nLocale): string =>
  t(i18nLocale, 'graph:parentChild.isParentOf', IS_PARENT_OF);

export const isChildOfLabel = (i18nLocale: I18nLocale): string =>
  t(i18nLocale, 'graph:parentChild.isChildOf', IS_CHILD_OF);
